var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "metadata-input-field-container" },
    [
      _vm.inputWindowKey == _vm.INPUT_TYPES.text
        ? [
            _c(
              "v-text-field",
              _vm._b(
                {
                  on: { input: _vm.emitChange },
                  model: {
                    value: _vm.fieldValue,
                    callback: function ($$v) {
                      _vm.fieldValue = $$v
                    },
                    expression: "fieldValue",
                  },
                },
                "v-text-field",
                _vm.inputAttrs,
                false
              )
            ),
          ]
        : _vm.inputWindowKey == _vm.INPUT_TYPES.dateTime
        ? [
            _c(
              "DateTimeMetadataInput",
              _vm._b(
                {
                  on: { input: _vm.emitChange },
                  model: {
                    value: _vm.fieldValue,
                    callback: function ($$v) {
                      _vm.fieldValue = $$v
                    },
                    expression: "fieldValue",
                  },
                },
                "DateTimeMetadataInput",
                _vm.inputAttrs,
                false
              )
            ),
          ]
        : _vm.inputWindowKey == _vm.INPUT_TYPES.monitoringLocation
        ? [
            _c(
              "ComboboxMetadataInput",
              _vm._b(
                {
                  attrs: {
                    label: "Monitoring Location",
                    items: _vm.discreteStationNames,
                  },
                  on: { input: _vm.emitChange },
                  model: {
                    value: _vm.fieldValue,
                    callback: function ($$v) {
                      _vm.fieldValue = $$v
                    },
                    expression: "fieldValue",
                  },
                },
                "ComboboxMetadataInput",
                _vm.inputAttrs,
                false
              )
            ),
          ]
        : _vm.inputWindowKey == _vm.INPUT_TYPES.monitoringComponent
        ? [
            _c(
              "ComboboxMetadataInput",
              _vm._b(
                {
                  attrs: {
                    label: "Monitoring Component",
                    items: _vm.stationCategoriesNameList,
                  },
                  on: { input: _vm.emitChange },
                  model: {
                    value: _vm.fieldValue,
                    callback: function ($$v) {
                      _vm.fieldValue = $$v
                    },
                    expression: "fieldValue",
                  },
                },
                "ComboboxMetadataInput",
                _vm.inputAttrs,
                false
              )
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }